import 'core-js/stable'
import 'regenerator-runtime/runtime'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementPlus from 'element-plus'
import 'element-plus/theme-chalk/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn';


 //1 引入中文


import textmore from './views/components/DTextmore/textmore.vue'

createApp(App).use(store).use(ElementPlus,{
    locale: zhCn
}).use(router).use(textmore).mount('#app')


